module.exports = __webpack_public_path__ + "static/media/document.55b6281a.svg";